import { styled } from 'linaria/react';

export const Container = styled.div<{ marginVertical?: string }>`
  position: relative;
  display: block;
  max-width: var(--layout-max-width);
  margin-block: ${({ marginVertical }) => marginVertical ?? 0}px;
`;

export const CarouselItem = styled.div`
  --container-width: 180px;
  --container-height: 96px;

  --img-width: 120px;
  --img-height: 80px;

  @media (--only-mobile) {
    --container-width: 108px;
    --container-height: 72px;

    --img-width: 84px;
    --img-height: 56px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  min-width: var(--container-width);
  width: var(--container-width);
  height: var(--container-height);
  border-radius: var(--space-50);
  box-shadow: var(--box-shadow-s);

  & picture {
    width: var(--img-width);
    height: var(--img-height);
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
`;

export const CarouselItemLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
